import React from 'react';
import moment from 'moment';
import { UncontrolledTooltip } from "reactstrap";
import ImagemFukyo from '../../Components/Imagem-Fukyo/Imagem-Fukyo';
import Geral from '../../Utils/Geral';


class Articles extends React.Component {
    constructor(props) {
        super(props);

        this.renderizaIconePublicarArtigo = this.renderizaIconePublicarArtigo.bind(this);
    }

    renderizaIconePublicarArtigo(item) {
        const {
            idConteudo, status, loading
        } = item;
        const _publicado = status === "Disponível",
            _textBtn = _publicado ? 'desativar artigo' : 'publicar artigo',
            _functionBtn = _publicado ? `desativar` : `publicar`,
            _classIcon = _publicado ? `far fa-eye-slash` : `far fa-eye`;
        return (
            <div className="row no-gutters">
                <div className="col-12 icones" id={`Tooltip-${idConteudo}`}>
                    {loading ? (
                        <div className="spinner-border spinner-border-sm text-primary" role="status" />
                    ) : (
                        <button onClick={() => this.props.mudaStatusArtigo(_functionBtn, idConteudo)}>
                            <i className={`${_classIcon}`}></i>
                        </button>
                    )}
                    <UncontrolledTooltip placement="top" target={`Tooltip-${idConteudo}`}>
                        {_textBtn}
                    </UncontrolledTooltip>
                </div>
            </div>
        )
    }
    render() {
        const {
            flagTelaDestaque, atualizarDestaque, permissaoEdicao, flagModalV2, addConteudoRelacionado
        } = this.props;

        const {
            titulo, secao, dtPublicacao, dtModificacao, usuarioModificacao, status, imagem, idConteudo, edicao, sigla, categoria
        } = this.props.item;

        const periodico = flagTelaDestaque ? '' : flagModalV2 ? '' : categoria.toLowerCase();
        const periodicov2 = flagTelaDestaque ? '' : flagModalV2 ? sigla.toLowerCase() : '' 
        const numEdicao = flagTelaDestaque ? '' : edicao;

        // const {
        //     periodico, numEdicao
        // } = flagTelaDestaque ? { periodico: '', numEdicao: '' } : this.props.match.params;

        return (
            <div className="row card-lista-artigos">
                <div className="col-12">
                    <div className="card">
                        <div className="card-body py-3">
                            <div className="row">
                                <div className="col-2 d-none d-lg-block pointer" onClick={() => flagTelaDestaque ? {} : flagModalV2 ?  this.props.history.push(`/conteudo/${periodicov2}/${numEdicao}/${idConteudo}`) : this.props.history.push(`/conteudo/${periodico}/${numEdicao}/${idConteudo}`)}>
                                    <ImagemFukyo
                                        className={`img-imagem-artigo img img-fluid`}
                                        src={imagem}
                                        alt={"imagem do artigo"}
                                    />
                                </div>
                                <div className="col-12 col-lg-10">
                                    <div className="row">
                                        <div className="col-12 col-lg-12">
                                            <div className="row py-1">
                                                <div className="col-12  text-left col-lg-8 text-lg-left pointer" onClick={() => flagTelaDestaque ? {} : flagModalV2 ?  this.props.history.push(`/conteudo/${periodicov2}/${numEdicao}/${idConteudo}`) : this.props.history.push(`/conteudo/${periodico}/${numEdicao}/${idConteudo}`)}>
                                                    <p className="m-0 text-truncate"><strong>Título: </strong>{titulo}</p>
                                                </div>
                                                {flagTelaDestaque || flagModalV2 ? (
                                                    <div className="col-12  text-left col-lg-4  text-lg-left">
                                                        <p className="m-0 text-truncate"> <strong>Seção: </strong>{secao} </p>
                                                    </div>
                                                ) : (
                                                    <div className="col-lg-12  text-lg-left">
                                                        <p className="m-0 text-truncate"> <strong>Seção: </strong>{secao} </p>
                                                    </div>
                                                )}
                                                {this.props.match.params.periodico === "gpv" && (
                                                    <div className="col-12  text-left col-lg-4  text-lg-left">
                                                        <span className={`badge badge-${Geral.badgeProductType(periodico)}`}>{periodico.toUpperCase()} {numEdicao}</span>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row align-items-center pt-2">
                                        <div className="col-3 d-lg-none pr-0 pointer" onClick={() => flagTelaDestaque ? {} : flagModalV2 ?  this.props.history.push(`/conteudo/${periodicov2}/${numEdicao}/${idConteudo}`) : this.props.history.push(`/conteudo/${periodico}/${numEdicao}/${idConteudo}`)}>
                                            <ImagemFukyo
                                                className={`img-imagem-artigo img img-fluid`}
                                                src={imagem}
                                                alt={"imagem do artigo"}
                                            />
                                        </div>
                                        <div className="col-5  text-center col-lg-3  text-lg-left">
                                            <strong><p className="m-0">Dt. publicação</p></strong>
                                            <span>{moment(dtPublicacao).format("DD/MM/YY")}</span>
                                        </div>
                                        <div className="col-6 text-center col-lg-3  text-lg-left d-none d-lg-block">
                                            <strong><p className="m-0">Dt. modificação</p></strong>
                                            <span>{moment(dtModificacao).format("DD/MM/YY")}</span>
                                        </div>
                                        {flagTelaDestaque ? (
                                            <div className="col-lg-6 text-right">
                                                <button className="btn btn-outline-success" onClick={() => atualizarDestaque(idConteudo)}>Atualizar destaque</button>
                                            </div>
                                        ) : flagModalV2 ? (
                                            <div className="col-lg-6 text-right">
                                                <button className="btn btn-outline-success" onClick={() => addConteudoRelacionado(idConteudo)}>Adicionar</button>
                                            </div>
                                        ): (
                                            <React.Fragment>
                                                <div className="col-6  text-center col-lg-3  text-lg-left d-none d-lg-block text-truncate">
                                                    <strong><p className="m-0">Usuário</p></strong>
                                                    <span>{usuarioModificacao}</span>
                                                </div>
                                                <div className="col-4  text-center col-lg-2  text-lg-left">
                                                    <strong><p className="m-0">Status</p></strong>
                                                    <span className={`badge badge-${status === 'Disponível' ?
                                                        'success' : 'secondary badge-opacity'}`}>{status}</span>
                                                </div>
                                                {permissaoEdicao && (
                                                    <div className="col-6 text-center col-lg-1  text-lg-left d-none d-lg-block">
                                                        {this.renderizaIconePublicarArtigo(this.props.item)}
                                                    </div>
                                                )}
                                            </React.Fragment>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Articles;